/**
 * MSAL Configuration for Microsoft Entra External ID Authentication
 *
 * Configures OAuth 2.0 / OpenID Connect authentication with:
 * - B2X_1_CustomerSignup user flow (sign-up and sign-in)
 * - Mandatory MFA via Conditional Access
 * - Backend API scope for access tokens
 */

import type { Configuration, RedirectRequest } from '@azure/msal-browser';

// Authority and domain should be derived from environment
const authority = import.meta.env.VITE_ENTRA_AUTHORITY || `https://facesheetauth.ciamlogin.com/`;
const knownAuthority = new URL(authority).hostname;

export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_ENTRA_FRONTEND_CLIENT_ID || '',
    authority: authority,
    knownAuthorities: [knownAuthority], // Explicitly trust the CIAM/Entra domain
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
};

// Backend API scope for access tokens
// Note: CIAM often uses the full App ID URI as the scope prefix
export const API_SCOPE = `api://${import.meta.env.VITE_ENTRA_BACKEND_CLIENT_ID}/access_as_user`;

// Login request configuration
export const loginRequest: RedirectRequest = {
  scopes: [
    'openid',
    'profile',
    'email',
    API_SCOPE,
  ],
  prompt: 'login', // Force Entra to show login form every time — no silent SSO bypass
};
